export enum UserPreferenceEvents {
    CONSTRUCTED = 'user-preference@constructed',
    FILLED = 'user-preference@filled',
    BEFORE_SAVE = 'user-preference@before-save',
    SAVED = 'user-preference@saved',
}
